module.exports = __webpack_public_path__ + "static/media/635.35224007.webp";